module.exports = __webpack_public_path__ + "img/win11.fe7b7eef.png";